// App.js
import React from 'react';
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import CustomerForm from './widgets/CustomerForm';



export default function EditCustomerScreen() {


  const { id } = useParams();
  return (
    <Box>
      <Box sx={{ display: 'flex' }}>
            <Box width={"100%"}>
          <CustomerForm formType={"edit"} formID= {id}>

          </CustomerForm>
        </Box>
      </Box>
      
    </Box>


  )
}